import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NavigationBar from "../../components/Heritage/NavigationBar";
import { Link } from "react-router-dom";

const ancientFitnessData = [
  {
    name: "Yoga",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjcQrk5kZ-c5mk2G19f-Y9hCs7-eWzj5nwCxkKB3sW_fyKv14gC40lJ_8PIw0uX_-G7KM&usqp=CAU",
    description:
      "An ancient physical, mental, and spiritual practice originating in Bharat over 5,000 years ago. Includes asanas (postures), pranayama (breathing), and dhyana (meditation).",
  },
  {
    name: "Surya Namaskar",
    image:
      "https://im.indiatimes.in/content/itimes/blog/2016/Jul/5/1467743095-5-reasons-why-you-should-start-your-day-with-surya-namaskar.jpg?w=400&h=267&cc=1&webp=1&q=75",
    description:
      "Sun Salutation – a series of yoga poses performed in a sequence to enhance flexibility, strength, and mindfulness.",
  },
  {
    name: "Mallakhamb",
    image:
      "https://media.insider.in/image/upload/c_crop,g_custom/v1557474679/cg5fjixsp1l7qrv7qhe3.jpg",
    description:
      "Aerial yoga-like traditional Indian sport involving poses on a vertical wooden pole or rope to develop agility and strength.",
  },
  {
    name: "Kalaripayattu",
    image:
      "https://www.traditionalsports.org/images/sports/asia/kalaripayattu/kalaripayattu-chuvadukal-11032020134050.jpg",
    description:
      "One of the oldest fighting systems in existence, developed in Kerala – combining combat techniques, yoga, and Ayurveda.",
  },
  {
    name: "Ayurvedic Lifestyle",
    image:
      "https://media.rnztools.nz/rnz/image/upload/s--9EwoLVtg--/ar_16:10,c_fill,f_auto,g_auto,q_auto,w_1050/v1710796239/4KT2YIB_AdobeStock_92068938_jpeg?_a=BACCd2AD",
    description:
      "Focuses on daily routines (dinacharya), seasonal changes (ritucharya), and nutrition to maintain physical and mental fitness.",
  },
];

const Fitness = () => {
  return (
    <>
      <NavigationBar />
      <Container className="py-5">
        <h1 className="text-center fw-bold mb-4">
          Ancient Fitness Practices of Bharat 🧘‍♂️
        </h1>
        <p className="text-center text-muted mb-5">
          Rooted in harmony, discipline, and inner strength – discover timeless
          wellness traditions.
        </p>

        <Row>
          {ancientFitnessData.map((item, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Link
                  to={`/heritage/fitness/${encodeURIComponent(item.name)}`}
                  state={{ topic: item }}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.name}
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>{item.name}</Card.Title>
                    <Card.Text>
                      {typeof item.description === "string"
                        ? item.description
                        : JSON.stringify(item.description)}
                    </Card.Text>
                  </Card.Body>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Ad Block */}
        <div className="bg-light border rounded text-center p-3 mt-4">
          <strong>Ad:</strong> Enroll in a certified Yoga & Ayurveda retreat in
          the Himalayas. Reconnect with your roots! 🕉️
        </div>
      </Container>
    </>
  );
};

export default Fitness;
